var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.06323 3.70322C9.03328 3.39503 10.0454 3.23983 11.0632 3.24322C15.2452 3.24322 18.0912 5.74322 19.7882 7.94722C20.6382 9.05322 21.0632 9.60422 21.0632 11.2432C21.0632 12.8832 20.6382 13.4342 19.7882 14.5392C18.0912 16.7432 15.2452 19.2432 11.0632 19.2432C6.88123 19.2432 4.03523 16.7432 2.33823 14.5392C1.48823 13.4352 1.06323 12.8822 1.06323 11.2432C1.06323 9.60322 1.48823 9.05222 2.33823 7.94722C2.85673 7.27004 3.43397 6.63993 4.06323 6.06422",
    stroke: "var(--text-hint)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0632 11.2432C14.0632 12.0389 13.7472 12.8019 13.1846 13.3645C12.6219 13.9272 11.8589 14.2432 11.0632 14.2432C10.2676 14.2432 9.50452 13.9272 8.94191 13.3645C8.3793 12.8019 8.06323 12.0389 8.06323 11.2432C8.06323 10.4476 8.3793 9.68451 8.94191 9.1219C9.50452 8.5593 10.2676 8.24323 11.0632 8.24323C11.8589 8.24323 12.6219 8.5593 13.1846 9.1219C13.7472 9.68451 14.0632 10.4476 14.0632 11.2432Z",
    stroke: "var(--text-hint)",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 2L19 21",
    stroke: "var(--text-hint)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordShow);
export default __webpack_public_path__ + "static/media/passwordShow.367dca906a8c0d8a981ba8afe6f1bf90.svg";
export { ForwardRef as ReactComponent };